/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Publish_HeaderInputs */

const en_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const fr_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier`)
};

const de_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen`)
};

const it_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicare`)
};

const ru_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публиковать`)
};

const es_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar`)
};

const zh_cn2_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布`)
};

const ja_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開`)
};

const hi_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशित करना`)
};

const pt_pt2_iconik_publish_publish_header = /** @type {(inputs: Iconik_Publish_Publish_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Iconik_Publish_Publish_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_publish_header = /** @type {((inputs?: Iconik_Publish_Publish_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Publish_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_publish_header(inputs)
	if (locale === "de") return de_iconik_publish_publish_header(inputs)
	if (locale === "it") return it_iconik_publish_publish_header(inputs)
	if (locale === "ru") return ru_iconik_publish_publish_header(inputs)
	if (locale === "es") return es_iconik_publish_publish_header(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_publish_header(inputs)
	if (locale === "ja") return ja_iconik_publish_publish_header(inputs)
	if (locale === "hi") return hi_iconik_publish_publish_header(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_publish_header(inputs)
	return en_iconik_publish_publish_header(inputs)
});